export default "__VITE_ASSET__DxZGyNkq__"